export default __webpack_public_path__ + "static/media/vks_phaseIII.6ac9da02.jpg";